<template>
  <div class="xunLinRankingPage">
    <van-tabs v-model="activeList" class="rankingChildTabs ggTabs">
      <van-tab title="个人榜" name="person"> </van-tab>
      <van-tab title="政区榜" name="administrative"> </van-tab>
      <van-tab title="责任榜" name="duty"> </van-tab>
    </van-tabs>
    <div class="TabsList">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
      >
        <div
          v-for="(item, index) in baselist"
          :key="item.id"
          class="itemList clear"
        >
          <p class="fl tit clear">
            <span v-if="parseFloat(index) < 3" :class="[index > 2 ? '' : 'pd']"
              ><img
                :src="baseUrl + 'xunlinOne.png'"
                alt=""
                v-if="index == '0'" />
              <img
                :src="baseUrl + 'xunlinTwo.png'"
                alt=""
                v-if="index == '1'" />
              <img
                :src="baseUrl + 'xunlinThree.png'"
                alt=""
                v-if="index == '2'"
            /></span>
            <span v-else class="spanText">{{ index + 1 }}</span>
          </p>
          <div v-if="activeList == 'person'" class="fl ggListMain">
            <dl class="dlBox">
              <dt>
                <van-image
                  fit="cover"
                  :src="item.avatar ? item.avatar : baseUrl + 'userDefault.png'"
                />
              </dt>
              <dd class="ddMain">
                <span
                  ><em>{{ item.realName }}</em>
                  <van-tag type="warning">{{ item.postName }}</van-tag>
                </span>
                <span class="lastSpan">{{ item.orgName }}</span>
              </dd>
            </dl>
          </div>
          <div v-if="activeList == 'administrative'" class="fl ggListMain">
            <p class="pName">{{ item.zqName ? item.zqName : "暂无" }}</p>
          </div>
          <div v-if="activeList == 'duty'" class="fl ggListMain">
            <p class="pName">{{ item.gridName }}</p>
          </div>
          <span class="itemPoints fr"
            >{{
              activeList == "person"
                ? item.forestNumbers
                : activeList == "administrative"
                ? item.forestNumber
                : item.forestNumber
            }}次</span
          >
        </div>
      </van-list>
      <div class="emptypage" v-if="noneRankListType">
        <van-image :src="baseUrl + 'empty.png'" />
      </div>
    </div>
    <p
      class="viewAllMain"
      v-if="!noneRankListType && !listType"
      @click="getAllRankingList"
    >
      查看全部
    </p>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "rankingList",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      activeList: "person",
      baselist: [],
      sourceList: [],
      loading: true,
      finished: false,
      pageNum: 0,
      pageSize: 99,
      total: "",
      finishedText: "",
      noneRankListType: false,
      clientType: getDeviceType(),
    };
  },
  props: {
    rankingTypeActive: {
      type: String,
    },
    listType: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.rankingTypeActive) {
        let type = "";
        type =
          this.rankingTypeActive == "rankingDay"
            ? 0
            : this.rankingTypeActive == "rankingMonth"
            ? 1
            : 2;

        this.getRankingList(type, this.activeList);
      }
    });
  },
  methods: {
    getRankingList(type, mode) {
      let _this = this;
      _this.loading = true;
      _this.finished = false;
      if (
        _this.pageNum != 0 &&
        _this.pageNum * _this.pageSize >= parseInt(_this.total)
      ) {
        return;
      }
      _this.pageNum += 1;
      _this.$api.xunLData
        .getXunLRank(_this.pageNum, _this.pageSize, type, mode)
        .then((res) => {
          if (res.code == "1" && res.data.list[0]) {
            _this.total = parseInt(res.data.total);
            _this.sourceList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            _this.loading = false;

            if (_this.pageNum * _this.pageSize >= _this.total) {
              _this.finished = true;
            } else {
              console.log(_this.listType);
              if (_this.listType) {
                _this.getRankingList(type, mode);
              }
            }
          } else {
            _this.loading = false;
            _this.finished = true;
            _this.noneRankListType = true;
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      let _this = this;
      _this.baselist = _this.baselist.concat(this.sourceList);
      if (!_this.listType) {
        _this.baselist = _this.baselist.splice(0, 5);
      }
      _this.baselist[0]
        ? (_this.noneRankListType = false)
        : (_this.noneRankListType = true);
    },
    getAllRankingList() {
      // let Url = window.location.protocol + "//" + window.location.host + "";
      let Url = window.location.hash.split("#")[0] || window.location.href.split("#")[0];
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      // "/slbktest/dhome-lzz-lzt-h5/#/allXunLRank?token=" +
      Url =
        Url +
        "#/allXunLRank?token=" +
        token +
        "&activeList=" +
        this.activeList +
        "&rankingTypeActive=" +
        this.rankingTypeActive +
        "&timestamp=" +
        timestamp;
        console.log("android===", Url);
      if (this.clientType == "android") {
        //android
        window.android.getInfo(105, Url);
      } else {
        //IOS
        window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
      }
    },
  },
  watch: {
    rankingTypeActive(newValue) {
      if (newValue) {
        this.baselist = [];
        this.pageNum = 0;
        this.total = 0;
        let type = "";
        type =
          newValue == "rankingDay" ? 0 : newValue == "rankingMonth" ? 1 : 2;
        this.getRankingList(type, this.activeList);
      }
    },
    activeList(newMode) {
      if (newMode) {
        this.baselist = [];
        this.pageNum = 0;
        this.total = 0;
        let type = "";
        type =
          this.rankingTypeActive == "rankingDay"
            ? 0
            : this.rankingTypeActive == "rankingMonth"
            ? 1
            : 2;
        this.getRankingList(type, newMode);
      }
    },
    listType(newBoolean) {
      if (newBoolean) {
        finishedText = "没有更多了";
      }
    },
  },
};
</script>
<style lang="less">
.xunLinRankingPage {
  width: 100%;
  padding: 0 16px;
  .rankingChildTabs {
    .van-tabs__wrap {
      height: 25px;
      .van-tabs__nav {
        float: left;
        .van-tab {
          background-color: #fff;
          border-radius: 12px;
          height: 25px;
          line-height: 25px;
          color: #0ab889;
          font-size: 12px;
          margin: 0 10px;
          min-width: 60px;
          border: 1px solid #0ab889;
        }
        .van-tab.van-tab--active {
          background-color: #f0faf7;
          color: #0ab889;
          border: 1px solid #0ab889;
        }
        .van-tabs__line {
          display: none;
        }
      }
    }
  }
  .TabsList {
    .itemList {
      width: 100%;
      height: 45px;
      margin: 15px 0;
      font-family: "PingFangSC-Regular", "PingFang SC";
      p.tit {
        display: inline-block;
        span {
          display: block;
          width: 25px;
          height: 45px;
          line-height: 45px;
          text-align: center;
          padding-top: 7px;
          img {
            height: 32px;
          }
        }
        .spanText {
          font-size: 16px;
          font-weight: 500;
          color: #abb2ba;
          padding: 0;
        }
      }
      .ggListMain {
        margin-left: 30px;
        width: 60%;
        .dlBox {
          dt {
            display: inline-block;
            width: 45px;
            height: 45px;

            .van-image {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
          .ddMain {
            width: calc(100% - 55px);
            display: inline-block;
            margin-left: 10px;
            > span {
              width: 100%;
              display: block;
              font-size: 12px;
              color: #8b8b8b;
              line-height: 17px;
              position: relative;
              em {
                display: inline-block;
                font-size: 16px;
                color: #333;
                font-weight: 400;
                line-height: 22px;
              }
              .van-tag {
                margin-left: 8px;
                display: inline-block;
                padding: 2px 6px;
                line-height: 16px;
                font-size: 12px;
                background-color: #ffa70a;
                vertical-align: top;
              }
            }
            .lastSpan {
              margin-top: 5px;
            }
          }
        }
        .pName {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          line-height: 45px;
        }
      }
      .itemPoints {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 45px;
      }
    }
    .emptypage {
      width: 85px;
      height: 115px;
      position: absolute;
      top: 25%;
      left: 50%;
      margin-left: -43px;
    }
  }
  .viewAllMain {
    width: 100%;
    height: 28px;
    background: #f0faf7;
    font-size: 12px;
    text-align: center;
    font-weight: 400;
    color: #0ab889;
    line-height: 28px;
    margin-bottom: 24px;
  }
}
</style>